import CryptoJS from 'crypto-js';

// Secret key để mã hóa/giải mã (nên lưu trong environment variable)
const SECRET_KEY = 'TextToVoiceAI_API_HUYDEV_2025';

/**
 * Tạo token bảo mật cho API request
 * @param {string} userId - ID của user
 * @param {number} timestamp - Timestamp hiện tại
 * @returns {string} - Token đã được mã hóa
 */
export const generateSecureToken = (userId, timestamp = Date.now()) => {
  try {
    // Tạo payload chứa thông tin cần thiết
    const payload = {
      userId: userId,
      timestamp: timestamp,
      nonce: Math.random().toString(36).substring(2, 15) // Random nonce để tránh replay attack
    };
    
    // Chuyển payload thành JSON string
    const payloadString = JSON.stringify(payload);
    
    // Mã hóa payload bằng AES
    const encrypted = CryptoJS.AES.encrypt(payloadString, SECRET_KEY).toString();
    
    // Tạo signature để đảm bảo tính toàn vẹn
    const signature = CryptoJS.HmacSHA256(encrypted, SECRET_KEY).toString();
    
    // Kết hợp encrypted data và signature
    const token = `${encrypted}.${signature}`;
    
    return token;
  } catch (error) {
    console.error('Error generating token:', error);
    throw new Error('Failed to generate secure token');
  }
};

/**
 * Xác thực token từ client
 * @param {string} token - Token cần xác thực
 * @returns {object|null} - Payload nếu hợp lệ, null nếu không hợp lệ
 */
export const verifyToken = (token) => {
  try {
    if (!token || typeof token !== 'string') {
      return null;
    }
    
    // Tách token thành encrypted data và signature
    const parts = token.split('.');
    if (parts.length !== 2) {
      return null;
    }
    
    const [encrypted, signature] = parts;
    
    // Kiểm tra signature
    const expectedSignature = CryptoJS.HmacSHA256(encrypted, SECRET_KEY).toString();
    if (signature !== expectedSignature) {
      return null;
    }
    
    // Giải mã payload
    const decrypted = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const payloadString = decrypted.toString(CryptoJS.enc.Utf8);
    
    if (!payloadString) {
      return null;
    }
    
    const payload = JSON.parse(payloadString);
    
    // Kiểm tra timestamp (token chỉ hợp lệ trong 1 giờ)
    const now = Date.now();
    const tokenAge = now - payload.timestamp;
    const maxAge = 60 * 60 * 1000; // 1 giờ
    
    if (tokenAge > maxAge) {
      return null;
    }
    
    return payload;
  } catch (error) {
    console.error('Error verifying token:', error);
    return null;
  }
};

/**
 * Tạo header với token bảo mật
 * @param {string} userId - ID của user
 * @returns {object} - Headers object
 */
export const createSecureHeaders = (userId) => {
  const token = generateSecureToken(userId);
  return {
    'X-Security-Token': token,
    'X-Request-Time': Date.now().toString(),
    'Content-Type': 'application/json'
  };
};